import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../../../CommonComponents/PiePage.component'
// import { PDFReader } from 'reactjs-pdf-reader'
import { getExtensionAndUrlPrefixFromName } from '../../../../CommonUtils'
import InputField from '../../../../CommonComponents/InputMUI'
// import Routes from '../../../../Layout/Routes'
import { CommunityLeadGetUserBusinessApi, getUploadedDocumentsApi, searchDocName, uploadzip,
    saveUpdateDocumentApi, getDocumentConfigApi, getDocumentCountApi, saveUpdateDocumentApiOther
 } from '../../../CommunityActionCreator'
// import { set } from 'date-fns'
import CustomPopup from '../../../../Popups/CustomPopup'
import { WEBSITE } from '../../../../CommonUtils'
import zipimage from '../../../Images/zipimage.png'
import fileBroken from '../../../Images/fileBroken.png'
import {LICENCE_ID} from '../../../../api-factory'
import PDFViewer from '../../../../CommonComponents/PdfViewr'

const AddUi = ({rowData}) => {
    const [objectDataOther, setObjectDataOther] = useState([])

    const [objectData, setObjectData] = useState({})
    const [message, setMessage] = useState('')
    const [loaderState, setLoaderState] = useState(false)
    const [docList, setDocList] = useState([])
    const [docRequired, setDocRequired] = useState([])
    const [docUploaded, setDcUploaded] = useState([])
    const navigate = useNavigate();
    const location = useLocation();
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [documentList, setDocumentList] = useState([])
    const [description, setdescription] = useState('')
    const [startingData, setStartingData] = useState({ file: '', description: '', docType: '', docName: "", docId: '' })
    const [otherDocumentUpload, setotherDocumentUpload] = useState(false)
    const [matchingData, setMatchingData] = useState([])
    const [matchingDiv, setMatchingDataDiv] = useState(false)
    const [docName, setdocName] = useState('')
    const [uploadedId, setUploadedOtherDocument] = useState('')
    const [customPopupState, setCustomPopupState] = useState(false)
    const [hideDirectOrExtract, setHideDirectOrExtract] = useState(true)

    useEffect(() => {
        // if (location.state !== null && location.state.rowData !== undefined) {
            getDetail()
            // forceUpdate()
            // getDocumentDetail()
            getUploadedDocuments()
            let changeStartingData = { ...startingData }

            objectDataOther[0] = changeStartingData

            setObjectDataOther(objectDataOther)


        // }
    }, [])

    const getUploadedDocuments = (data) => {

        getUploadedDocumentsApi(rowData.userId, callBack => {
            setDocumentList(callBack)
        })
    }
    const uploadOtherOpen = () => {
        if (otherDocumentUpload === true) {
            setotherDocumentUpload(false)

        } else {
            setotherDocumentUpload(true)

        }
    }

    const getDetail = () => {
        CommunityLeadGetUserBusinessApi(rowData.userId,
            callBack => {

                if (Object.keys(callBack).length > 0) {
                    if (callBack.sourceOfIncome !== 'salary') {
                        getDocumentDetail(callBack)
                    } else {
                        getDocumentDetail('')
                    }

                } else {
                    getDocumentDetail('')
                }
            }, error => {

            })



    }

    const getDocumentDetail = (businessData) => {
        let data = {
            licenseId: window.sessionStorage.getItem('licenseId') || LICENCE_ID,
            product: 'USER',
            bussinessType: rowData.sourceOfIncome === 'salary' ? '' : businessData.typeOfConsititution ? businessData.typeOfConsititution : '',
            sourceOfIncome: rowData.sourceOfIncome,
            loanId: rowData.loanId
        }
        getDocumentCountApi(data, count => {
            getDocumentConfigApi(1, count, data,
                callBack => {
                    if (callBack.length > 0) {
                        // setDocList(callBack)
                        let docArr = []
                        callBack.forEach(element => {
                            // if (element.name === 'GST Registration Certificate' || element.name === 'MSME Certificate') {
                            //     console.log(element.name)
                            //     console.log(businessData)
                            //     if (element.name === 'GST Registration Certificate') {
                            //         console.log(element)
                            //         if (!docRequired.includes(element.documentId)) {
                            //             docRequired.push(element.documentId)
                            //         }
                            //         docArr.push(element)
                            //     } else if (element.name === 'MSME Certificate' && businessData.msmeAvailable) {
                            //         if (!docRequired.includes(element.documentId)) {
                            //             docRequired.push(element.documentId)
                            //         }
                            //         docArr.push(element)
                            //     }
                            // } else {
                            // console.log(element)
                            if (element.mandatoryOrNot && element.uploadedOrNot === 'N') {
                                if (!docRequired.includes(element.documentId)) {
                                    docRequired.push(element.documentId)
                                }

                            }
                            docArr.push(element)

                            setDocList(docArr)
                            forceUpdate()

                            // }
                        });

                        setDocList(docArr)
                        setDocRequired(docRequired)
                    }
                }, error => {

                })
        }, error => {

        })
    }

    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData[type] = e
        setObjectData(changeObjectData)
        setMessage({})
    }

    const saveHandler = (e) => {
        // if (e === 'save') {
        //     if (docUploaded.length >= docRequired.length) {
        //         if (!window.location.href.includes('/external')) {
        //             if (location.state ? location.state.communityId : null) {
        //                 navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: location.state.rowData, page: 'communityLeads' } })
        //             } else if (location.state ? location.state.qrId : null) {
        //                 let data = location.state.rowData
        //                 data.qrId = location.state ? location.state.qrId : null
        //                 navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
        //             } else {
        //                 window.location.href.includes('admin') ?
        //                     navigate(Routes.SUPER_ADMIN_ALL_LEADS)
        //                     : navigate(Routes.COMMUNITY_ALL_LEADS)
        //             }
        //         } else if (window.location.href.includes("/external")) {
        //             setCustomPopupState(true)
        //         }
        //     } else {
        //         setMessage('Please upload all documents')
        //     }
        // } else if (e === 'close') {

        //     if (location.state ? location.state.communityId : null) {
        //         let data = location.state.rowData
        //         data.communityId = location.state ? location.state.communityId : null
        //         navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
        //     }
        //     else if (location.state ? location.state.qrId : null) {
        //         let data = location.state.rowData
        //         data.qrId = location.state ? location.state.qrId : null
        //         navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
        //     }
        //     else {
        //         navigate(window.location.href.includes('admin') ? Routes.SUPER_ADMIN_ALL_LEADS : Routes.COMMUNITY_ALL_LEADS, { state: { rowData: location.state.rowData } })
        //     }
        // } else if (e === 'back') {
        //     if (!window.location.href.includes('/external')) {
        //         navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_LOAN : Routes.COMMUNITY_ADD_LEAD_LOAN, { state: { rowData: location.state.rowData, communityId: location.state ? location.state.communityId : null } })
        //     } else {
        //         navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_LOAN, { state: { rowData: location.state.rowData } })
        //     }
        // }
    }

    const changeHandler = (e, id, size, fileType) => {
        // console.log(fileType)
        if (e.target.files[0]) {
            let check = (fileType)
            check.map((data, i) => {
                if (e.target.files[0].name.includes(data)) {
                    if (Number(e.target.files[0].size) > Number(size)) {
                        alert('file size exceeded')
                    } else {
                        if (!docUploaded.includes(e.target.id)) {
                            docUploaded.push(e.target.id)
                            setDcUploaded(docUploaded)
                        }
                        docList.forEach(element => {
                            if (element.documentId === e.target.id) {
                                element.docDescription = e.target.files[0].name
                            }
                        })
                        setDocList(docList)
                        forceUpdate()
                        saveUpdateDocumentApi(e.target.files[0], e.target.id, rowData,
                            callBack => {
                                setLoaderState(false)
                            },
                            error => {
                                setLoaderState(false)
                            })
                    }
                }
            })
        }


    }



    const descriptionHandler = (e, type, key) => {
        let changeObjectData = { ...objectDataOther[key] }
        changeObjectData[type] = e
        objectDataOther[key] = changeObjectData
        setObjectData(changeObjectData)
        if (type === 'docName') {
            setMessage("")
            if (e) {
                searchDocName(e, callBack => {
                    setMatchingData(callBack.data)
                    setMatchingDataDiv(key)
                })
            } else {
                setMatchingDataDiv(false)

            }
        }
    }

    const uploadZipFIleWIthType = (file, type, i) => {
        if (file) {
            setLoaderState(true)
            uploadzip(file, type, rowData ? rowData.loanId : '',
                rowData ? rowData.userId : '', objectData.docName, objectData.description, callBack => {
                    if (callBack && callBack.data) {
                        descriptionHandler(false, 'showHiddenExtractORDirectUpload', i)
                        getDetail()
                        getUploadedDocuments()
                    }
                    setLoaderState(false)

                })
        } else {
            alert("Please Select File")
        }

    }

    const otherDocumentHandler = (e, id, type) => {
        var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (objectDataOther && objectDataOther[id] && objectDataOther[id].docName) {
            if (specialChar.test(objectDataOther[id].docName)) {
                setMessage("Doc name should not contain special character!!")

            } else {
                setMessage("")
                if ((e.target.files && e.target.files[0]) || objectDataOther[id].file) {
                    if ((e.target.files && e.target.files[0].type === 'application/zip') || objectDataOther[id].file) {
                        descriptionHandler(true, 'showHiddenExtractORDirectUpload', id)
                        descriptionHandler(e.target.files ? e.target.files[0] : objectDataOther[id].file, 'file', id)
                        if (type && (type === 'extract' || type === 'directUpload')) {
                            uploadZipFIleWIthType(objectDataOther[id].file, type, id)
                        }
                    } else {
                        setLoaderState(true)
                        saveUpdateDocumentApiOther(e.target.files[0], objectDataOther[id].docName, objectDataOther[id].documnetId, rowData, objectDataOther[id].description, 0,
                            callBack => {
                                setLoaderState(false)
                                getUploadedDocuments()
                            },
                            error => {
                                setLoaderState(false)
                            })

                    }
                }
            }
        } else { console.log(objectDataOther, "nth") }
    }


    const mainActionHandler = (type, mainKey) => {
        if (type === 'mainAdd') {
            let changeStartingData = { ...startingData }
            objectDataOther[mainKey + 1] = changeStartingData
            setObjectDataOther(objectDataOther)
            setMatchingDataDiv(false)
            forceUpdate()

        } else if (type === 'mainRemove') {
            setMatchingDataDiv(false)

            if (objectDataOther.length > 1 && objectDataOther[mainKey] !== undefined) {
                if (objectDataOther[mainKey].id !== undefined && objectDataOther[mainKey].id !== null && objectDataOther[mainKey].id !== '') {

                } else {
                    objectDataOther.splice(mainKey, 1)
                    setObjectDataOther(objectDataOther)
                    forceUpdate()
                }
            }
        }
    }
    const docNameHandler = (data, type, key) => {
        let changeObjectData = { ...objectDataOther[key] }
        changeObjectData['docName'] = data.doc_name
        changeObjectData['documnetId'] = data.document_id
        objectDataOther[key] = changeObjectData
        setObjectData(changeObjectData)
        setMatchingDataDiv('')

    }
    const customPopupAction = (e) => {
        if (e === 'yes') {
            navigate(WEBSITE)
            // <Link to={{
            //     pathname: Routes.COMMUNITY_ADD_LEAD_PERSONAL,
            // }} >
        }
    }
    return (
        <div className='container card'>
            {loaderState ?
                <Loader />
                : null}
            {customPopupState ?
                <CustomPopup actionHandler={customPopupAction} message="Thank you for filling out your loan information!" />
                : null}
            <PiePage
                totalPage={5}
                currentPage={5}
                heading={'Add Documents'}
            />
            <div className='row'>
                {docList.length > 0 ?
                    docList.map((list, i) => {
                        return (
                            // <div className='mb-3 col-sm-12' key={i}>
                            //     <h4>{list.name}</h4>
                            //     <input type="file"
                            //         id={list.documentId}
                            //         style={{ display: 'none' }}
                            //         // onChange={e => inputChange(e)}
                            //         accept={list.docTypesAllowed.length > 0 ? list.docTypesAllowed.join(', ') : '*'}
                            //         data-max-size={list.sizeLimit}
                            //         onChange={e => changeHandler(e, list.documentId, list.sizeLimit)}
                            //     // value={objectData.fileValue}
                            //     />
                            //     <label htmlFor={list.documentId} className="choose-file-input">
                            //         <i className="fa fa-cloud-upload" />
                            //         <span>{list.docDescription === undefined ? 'Select File' : list.docDescription}</span>
                            //     </label>
                            // </div>
                            <div className='col-sm-4 col-xs-12' key={i}>
                                <h6 style={{ marginTop: '15px', textDecoration: 'underline' }}><b>{list.name + (list.mandatoryOrNot && list.uploadedOrNot === 'N' ? '*' : '')}</b></h6>
                                {list.uploadedOrNot === 'Y' ? <span><span>Already Uplaoded &nbsp;<i className='fa fa-check' style={{ color: 'green' }}></i></span> </span> : ""}
                                <div className='d-flex' style={{ marginBottom: '15px' }}>
                                    <div className="image-upload-wrap-multi">
                                        <input
                                            value={objectData.fileValue}
                                            id={list.documentId}
                                            data-max-size={list.sizeLimit}
                                            accept={list.docTypesAllowed.length > 0 ? list.docTypesAllowed.join(', ') : '*'}
                                            className="file-upload-input-multi" type='file' onChange={e => changeHandler(e, list.documentId, list.sizeLimit, list.docTypesAllowed)} />

                                    </div>
                                    <div className="drag-text-multi">
                                        <div> {list.docDescription ? list.docDescription : 'Select File'}&nbsp;&nbsp;{list.docDescription ? <i className='fa fa-check' style={{ color: 'green' }}></i> : ""} </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    : null}

            </div>
            <button className='cred-btn mb-3' style={{ width: '200px',fontSize:'14px' }} onClick={() => uploadOtherOpen()}>upload other documents</button>
            {/* {console.log(objectDataOther)} */}
            {otherDocumentUpload && objectDataOther.map((data, i) => {

                return (
                    <div className='row' key={i}>
                        <div className='card-header'>
                            <div className='btn-group'>
                                <button
                                    className='cred-btn center-block mr-3'
                                    onClick={e => mainActionHandler('mainAdd', i)}
                                ><i className='fa fa-plus' /></button>
                                <button
                                    className='cred-btn center-block'
                                    onClick={e => mainActionHandler('mainRemove', i)}
                                ><i className='fa fa-minus' /></button>
                            </div>
                        </div>
                        <div className='col-sm-4 col-xs-12'>
                            <InputField
                                label="Document Name"
                                variant="outlined"
                                name={'docName' + i}
                                id={'docName' + i}
                                type="text"
                                onChange={e => descriptionHandler(e, 'docName', i)}
                                size="small"
                                value={data.docName}
                            />
                            <div style={{ marginBottom: '20px' }}>
                                {matchingData && matchingDiv === i ?
                                    <ul className="designation-list" style={{ marginTop: '-43px', zIndex: '9999' }} >
                                        {matchingData.map((data, j) => {
                                            return (
                                                <li key={j} value={data.document_id} onClick={() => docNameHandler(data, 'docName', i)} >{data.doc_name}</li>
                                            )
                                        })}
                                    </ul>
                                    : ""}
                            </div>
                        </div>

                        <div className='col-sm-4 col-xs-12'>
                            <InputField
                                label="Description"
                                variant="outlined"
                                name={'description' + i}
                                id={'description' + i}
                                type="text"
                                onChange={e => descriptionHandler(e, 'description', i)}
                                size="small"
                                value={data.description}
                            />

                        </div>

                        <div className='col-sm-2 col-xs-12'>
                            <div className="image-upload-wrap-multi" style={{ marginBottom: '10px', padding: '10px', width: '100%', backgroundSize: '20%' }}>
                                <input
                                    className="file-upload-input-multi" type='file' onChange={(e) => otherDocumentHandler(e, i)} />
                            </div>


                        </div>
                        <div className='col-sm-2 col-xs-12' style={{ marginTop: '36px' }}>
                            {data.docName ? data.docName : 'Select File'}
                        </div>
                        {
                            data.showHiddenExtractORDirectUpload ?
                                <><div className='col-sm-7 col-xs-12'>
                                </div>
                                    <div className='col-sm-4 row col-xs-12' id={'directOrExtract' + i}>
                                        <div className='col-sm-6 col-xs-12 text-right'>
                                            <button style={{ color: "white" }} className="cred-btn" type="button" onClick={(e) => otherDocumentHandler(e, i, 'directUpload')}>
                                                Direct Upload
                                            </button>
                                        </div>
                                        <div className='col-sm-6  col-xs-12 text-right'>
                                            <button style={{ color: "white" }} className="cred-btn " type="button" onClick={(e) => otherDocumentHandler(e, i, 'extract')}>
                                                Extract and Upload
                                            </button>
                                        </div>
                                    </div></> : ''
                        }

                    </div>
                )
            })}
            <div id="docNameHelp" className="form-text text-danger">{message}</div>

            {documentList && documentList.length > 0 ?
                <div className="accordion-item">
                    <h2 className="accordion-header border-bottom-heading" id="headingDocuments">
                        <button style={{ color: "white" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDocuments" aria-expanded="false" aria-controls="collapseDocuments">
                            Already Uploaded Documents
                        </button>
                    </h2>
                    <div id="collapseDocuments" className="accordion-collapse collapse" aria-labelledby="headingDocuments" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className='row'>
                                {documentList.map((data, i) => {
                                    if (data.documentUrl) {
                                        const fileExtensionAndPrefix = getExtensionAndUrlPrefixFromName(data.documentUrl)
                                        const fileExtension = fileExtensionAndPrefix.extension
                                        const url = fileExtensionAndPrefix.urlPrefix + fileExtension + ";base64," + encodeURI(data.documentInString)
                                        return (
                                            <div className='col-sm-2 col-xs-12 document-pdf text-center' key={i}>
                                                {
                                                    fileExtension.includes('zip') ?
                                                        <div className='document-box'>
                                                            <h6 className='text-center' ><b>{data.documentName + '.zip'}</b></h6>
                                                            <img src={zipimage} alt="" width='100%' />
                                                            <div className='text-center'>
                                                                <a target='_blank' className='cred-btn mt-5 noDecoration' href={data.documentUrl}>Download</a>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className='document-box'>
                                                            <a href={data.documentUrl} target='_blank'>  <h6 className='text-center' ><b>{data.documentName}</b></h6></a>
                                                            {data.documentUrl.includes('pdf') ?
                                                                // <PDFReader url={url} showAllPage={true} />
                                                                <PDFViewer url={url} /> 
                                                                : data.documentUrl.includes('png') || data.documentUrl.includes('jpg') || data.documentUrl.includes('jpeg')
                                                                    ? <img src={url} alt="" width='100%' /> :
                                                                    <div>
                                                                        <img src={fileBroken} alt="" width='100%' />
                                                                        <div className='text-center'>
                                                                            <a target='_blank' className='cred-btn mt-5 noDecoration' href={data.documentUrl}>Download</a>
                                                                        </div>
                                                                    </div>}
                                                        </div>
                                                }
                                                <br />
                                            </div>
                                        )
                                    }

                                })}
                            </div>

                        </div>
                    </div>
                </div>
                : null}
            {/* {
                window.location.href.includes("/admin/leadDetail") ? "" :
                    <div className='mb-3 row' style={{ marginTop: '50px' }}>
                        <div className="col-12 text-center">
                            <div id="Help" className="form-text text-danger">{message}</div>
                            {
                                !window.location.href.includes('/external') ?
                                    <button className="cred-btn cancel-btn" onClick={e => saveHandler('close')}>Close</button>
                                    :
                                    <a href={WEBSITE}> <button type="button" className="cred-btn">Close</button></a>
                            }
                            <button className="cred-btn cancel-btn" onClick={e => saveHandler('back')}>Back</button>
                            <button className="cred-btn" onClick={e => saveHandler('save')}>Save and Continue</button>
                        </div>
                    </div>
            } */}
        </div>
    )
}

export default AddUi;